import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getCategoryList = async (params: object) => {
  return await GET({
    url: Api.getCategoryList,
    params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
export const queryZoneSalesList = async (params: object) => {
  return await GET({
    url: Api.queryZoneSalesList,
    params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
export const querySaleList = async (params: object) => {
  return await POST({
    url: Api.querySaleList,
    data: params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
export const getPath = async (params: object) => {
  return await POST({
    url: Api.getPath,
    params,
    headers: {
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}

export const regionList = async (params: object) => {
  return await GET({
    url: Api.regionList,
    params,
    showError: false
  })
}

export const activityList = async (params: object) => {
  return await GET({
    url: Api.activityList,
    params,
    showError: false
  })
}

export const getActivityData = async (params: object) => {
  let appInfo = ''
  try {
    appInfo = await window.bd.getHeaderParams(true)
  } catch (e) {
    if (navigator.userAgent.includes('sensors-verify')) {
      appInfo = e
    }
  }
  return await POST({
    url: Api.getActivityData,
    data: params.formData,
    headers: {
      beidou: appInfo,
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    showError: false
  })
}
